import { CartAdditionStatus, GroceryItem } from "../types/mealPlan";

/**
 * Add entire meal plan grocery list to Kroger cart (NEW SIMPLIFIED API)
 */
export const addMealPlanToCart = async (
  mealPlanId: string,
  userToken: string
): Promise<CartAdditionStatus> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/kroger/cart/add-meal-plan`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        mealPlanId,
      }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};

/**
 * Get cart addition status for a meal plan
 */
export const getCartAdditionStatus = async (
  mealPlanId: string,
  userToken: string
): Promise<CartAdditionStatus> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/kroger/cart/status/${mealPlanId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};

/**
 * Toggle grocery list items as "already have" or not
 */
export const toggleGroceryListItems = async (
  mealPlanId: string,
  itemNames: string[],
  userToken: string
): Promise<{
  success: boolean;
  groceryList?: GroceryItem[];
}> => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/meals/plans/${mealPlanId}/grocery-list/toggle`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        itemNames,
      }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Request failed: ${response.status}`);
  }

  return await response.json();
};
